var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mdt-button",attrs:{"data-test":_vm.testKey && `${_vm.testKey}-button`}},[_c('div',{staticClass:"flex-center pointer no-userselect button",class:[{
      'button-disabled': _vm.disabled,
    }, `theme-${_vm.theme}`]},[_c('i',{class:_vm.icon})])])
}
var staticRenderFns = []

export { render, staticRenderFns }